import Layout from '../components/Layout';
import Seo from '../components/Seo';

export default function Cookies() {
  return (
    <Layout>
      <Seo title="Cookiepolicy – Specialists.no" description="Cookiepolicy for Specialists.no." canonical="https://specialists.no/cookies" />
      <section className="bg-[#0A1F44] text-white py-14">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-4xl font-bold">Cookiepolicy</h1>
        </div>
      </section>
      <section className="py-14">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-5 text-[#334155]">
          <p>Specialists.no bruker minimal sporing — vi benytter sessionStorage (ikke persistent) for å forstå hvordan nettstedet brukes. Ingen tredjepartssporing, ingen reklame-cookies.</p>

          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-6">Sessionlagring</h2>
          <p>Vi genererer en anonym sesjon-ID når du åpner nettstedet. Den lagres kun i nettleseren og slettes når du lukker fanen. Den brukes til å forstå brukerflyt — aldri til å identifisere deg.</p>

          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-6">Samtykkepreferanse</h2>
          <p>Hvis du velger "Avvis" i cookie-banneret, lagrer vi denne preferansen i localStorage (en persistent nøkkel kalt <code>cookie_consent</code>). Da sendes ingen sporingsdata.</p>

          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-6">Ingen tredjepartssporing</h2>
          <p>Vi bruker ikke Google Analytics, Facebook Pixel, eller lignende. All analyse skjer på våre egne servere.</p>
        </div>
      </section>
    </Layout>
  );
}
